<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="image_container" fxLayoutAlign="center center" *ngIf="imageUrl && imageUrl.length > 0">
  <img [httpSrc]="imageUrl" style="height: 160px" />
</div>
